import { Tooltip } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldCheckbox from '@/components/shared/form/FieldCheckbox';
import { FAST_MODE_ENABLED } from '@/configs/env';
import { fastModeStore } from '@/stores/global/RootStore';
import { useDevices } from '@/utils/devices';

type FastModeCheckboxProps = {
  className?: string;
};

const FastModeCheckbox: React.FC<FastModeCheckboxProps> = ({ className }) => {
  const { isPhone } = useDevices();

  if (!FAST_MODE_ENABLED) {
    return null;
  }

  return (
    <Tooltip label="Ответ приходит быстрее, но расходует больше лимита модели" disabled={isPhone} withArrow>
      <span className={className}>
        <FieldCheckbox
          size="sm"
          label="Ускоренный режим"
          checked={fastModeStore.enabled}
          onToggle={fastModeStore.toggle}
        />
      </span>
    </Tooltip>
  );
};

export default observer(FastModeCheckbox);
